import React from 'react';

import { Start } from '@mui/icons-material';
import { Drawer, IconButton, Toolbar, useTheme } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import PeriodJobActionButton from './job_action_button';
import PeriodJobDetailPage from './page';

const PeriodJobDetailLayout = () => {
  const theme = useTheme();

  const navigate = useNavigate();
  const { id: periodJobId } = useParams();

  const [open, setOpen] = React.useState(false);
  const onDrawerCloseHandler = React.useCallback(() => {
    setOpen(false);
    navigate('/jobs', { replace: true });
  }, [navigate]);

  React.useEffect(() => {
    let timeoutId: string | number | NodeJS.Timeout | undefined;
    if (periodJobId) {
      // Wait for React Route changing route to play open animation
      timeoutId = setTimeout(() => {
        setOpen(true);
      }, 10);
    } else {
      onDrawerCloseHandler();
    }

    return () => clearTimeout(timeoutId);
  }, [periodJobId, onDrawerCloseHandler]);

  return (
    <Drawer
      open={open}
      anchor="right"
      variant="persistent"
      onClose={onDrawerCloseHandler}
      PaperProps={{
        variant: 'outlined',
        sx: { width: '100%', maxWidth: theme.breakpoints.values.sm },
      }}
    >
      <Toolbar>
        <IconButton size="large" edge="start" color="inherit" onClick={onDrawerCloseHandler}>
          <Start />
        </IconButton>
        <div style={{ flexGrow: 1 }} />
        <PeriodJobActionButton periodJobId={periodJobId ?? ''} />
      </Toolbar>

      <PeriodJobDetailPage />
    </Drawer>
  );
};

export default PeriodJobDetailLayout;
